<p-message
  *ngIf="demoModeService.isDemo$ | async"
  severity="warn"
  styleClass="p-mb-2 demo-mode-banner"
  text="Demo Mode is active — data shown is for demonstration purposes only"
></p-message>
<p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-2"></p-breadcrumb>
<p-overlayPanel #dashboardPanel appendTo="body" styleClass="dashboard-search-panel">
  <div class="dashboard-search-list">
    <input
      #dashboardSearchInput
      type="text"
      pInputText
      [(ngModel)]="dashboardSearch"
      placeholder="Search dashboards..."
      class="full-width p-mb-2"
      (input)="filterDashboards()"
    >
    <div class="dashboard-search-items">
      <button
        *ngFor="let d of filteredDashboards"
        type="button"
        class="dashboard-search-item"
        (click)="onDashboardSelect(d.slug); dashboardPanel.hide()"
      >
        <i class="pi {{ d.icon }}"></i>
        <span>{{ d.name }}</span>
      </button>
      <div *ngIf="!filteredDashboards.length" class="dashboard-search-empty">
        No dashboards found
      </div>
    </div>
  </div>
</p-overlayPanel>
<div
  class="layout-dashboard jobsv2-{{ colorScheme.colorScheme.value }}"
  #layout
>
  <div class="tabView">
    <div
      class="dashboard-period-bar p-d-flex p-flex-column p-flex-md-row p-jc-md-between p-ai-md-center p-px-3 p-pt-2"
      *ngIf="settings$ | async as settings"
    >
      <div class="dashboard-title-wrapper" *ngIf="dashboardDisplay.showTitle">
        <h1 class="p-mb-2 p-mb-md-0">
          <i *ngIf="dashboardIcon" [class]="dashboardIcon" style="font-size: 0.75em" class="p-mr-3"></i>{{ dashboardTitle }}
        </h1>
      </div>
      <div
        class="header-dropdowns p-d-grid p-grid-cols-1 p-gap-2 p-grid-cols-md-auto p-d-md-flex"
        *ngIf="dashboardDisplay.showPeriodSelectors"
      >
        <p-dropdown
          [ngModel]="settings.period"
          (ngModelChange)="setPeriod($event)"
          appendTo="body"
          [options]="periodOptions"
          [filter]="true"
          filterPlaceholder="Search period..."
        ></p-dropdown>
        <p-calendar
          *ngIf="!settings.isMonthMode"
          appendTo="body"
          [(ngModel)]="customPeriod"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="full-width"
          inputId="range"
          [disabled]="settings.customPeriodDisabled"
          (onClose)="validateCustomPeriod()"
        ></p-calendar>
        <p-calendar
          *ngIf="settings.isMonthMode"
          [(ngModel)]="month"
          dataType="string"
          view="month"
          dateFormat="MM yy"
          (onSelect)="setMonth(month)"
          showIcon="true"
          iconDisplay="input"
          [readonlyInput]="true"
        />
        <p-dropdown
          *ngIf="settings.showComparedTo && dashboardDisplay.showComparedTo"
          [ngModel]="settings.comparedTo"
          (ngModelChange)="setComparedTo($event)"
          appendTo="body"
          [options]="comparedToOptions"
        ></p-dropdown>
        <p-dropdown
          *ngIf="dashboardDisplay.showCurrency"
          [ngModel]="settings.currency"
          (ngModelChange)="setCurrency($event)"
          appendTo="body"
          [options]="currencyOptions"
        ></p-dropdown>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>